var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5727 11.656C9.67764 12.3263 8.56604 12.7234 7.3617 12.7234C4.40052 12.7234 2 10.3229 2 7.3617C2 4.40052 4.40052 2 7.3617 2C10.3229 2 12.7234 4.40052 12.7234 7.3617C12.7234 8.56604 12.3263 9.67764 11.656 10.5727L13.7757 12.6924C14.0748 12.9916 14.0748 13.4765 13.7757 13.7757C13.4765 14.0748 12.9916 14.0748 12.6924 13.7757L10.5727 11.656ZM11.1915 7.3617C11.1915 9.47684 9.47684 11.1915 7.3617 11.1915C5.24657 11.1915 3.53191 9.47684 3.53191 7.3617C3.53191 5.24657 5.24657 3.53191 7.3617 3.53191C9.47684 3.53191 11.1915 5.24657 11.1915 7.3617Z",
    fill: "#011235"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.8e3730741440865fa77b826df5d1fa66.svg";
export { ForwardRef as ReactComponent };